import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { useMobileOrientation, isMobile, useDeviceSelectors, osName } from 'react-device-detect';

export default function usePhoneMode() {
    const theme = useTheme();
    const phoneWidth = useMediaQuery(theme.breakpoints.down("sm"));
    const { isLandscape } = useMobileOrientation();
    const [selectors] = useDeviceSelectors()
    const { deviceType } = selectors;

    const phoneMode = isMobile && !isLandscape && deviceType != 'tablet';

    return { isMobile: phoneWidth || isMobile, isLandscape, phoneMode }
}